import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { registerBlockRequest } from '../../../apiclients/streamsapi_bridge';
import { MDBAlert } from 'mdb-react-ui-kit';

const AuthorizedBlockUser = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const registerBlockUser = async (e) => {
        try {
            setInternalError(false);
            props.setIsloading(true);
            const userid = props.userInfoList.map((user) => user.id);
            let update = {
                reqid: 137,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            }
            if (props.actionType && props.actionType === 1) {
                update.register_id = userid;
            } else {
                update.blocked_id = userid;
            }
            console.log("final request is ::::::::::::::::: "+JSON.stringify(update));
            let deleteaddressReponse = await registerBlockRequest(update);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteaddressReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.message);


            } else {
                localStorage.setItem("f_message", delInfo.message);

            }
            props.onClose();
            navigate("/securityregistrationlanding", {
                state: { tab: "tab4" },
            });
            window.location.reload();
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }

    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{props.actionType === 1 ? t("RegisterUserOnDevicetxt") : t("BlockUserOnDevicetxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => registerBlockUser(e)}>
                    {t("remove")}</button>
            </div>

        </>
    )
});

export default AuthorizedBlockUser
